import Vue from 'vue'
import './plugins/vuetify'
import VueHtmlToPaper from 'vue-html-to-paper';
import VueMq from 'vue-mq'

import App from './App.vue'
import router from './router'
import store from './store'

import '../public/vuetify.css'

import VeeValidate from 'vee-validate';
import 'roboto-fontface/css/roboto/roboto-fontface.css'

import 'material-design-icons-iconfont/dist/material-design-icons.css'
import VuetifyConfirm from 'vuetify-confirm'

//import '@mdi/font/css/materialdesignicons.css' // Ensure you are using css-loader
//import Vuetify from 'vuetify'
//import 'font-awesome/css/font-awesome.min.css' // Ensure you are using css-loader
Vue.use(VueMq, {
  breakpoints: {
    mobile: 450,
    tablet: 900,
    laptop: 1250,
    desktop: Infinity,
  }
})
const options = {
  name: '_blank',
  specs: [
    'fullscreen=yes',
    'titlebar=yes',
    'scrollbars=yes'
  ],
  styles: [
    'https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css',
    'https://unpkg.com/kidlat-css/css/kidlat.css'
  ]
}
Vue.use(VueHtmlToPaper, options);

Vue.config.productionTip = false
Vue.use(VeeValidate, { fieldsBagName: 'formFields' });
Vue.use(VuetifyConfirm, {
  buttonTrueText: 'Accept',
  buttonFalseText: 'Discard',
  color: 'warning',
  icon: 'warning',
  title: 'Warning',
  width: 350,
  property: '$confirm'
})
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
